import _ from 'lodash';
import * as actions from '../actions/landing';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_GLOWFORGE_LANDING_PAGE: {
      return Object.assign({}, state, {
        glowforgeLandingPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_PROJECT_PICS: {
      return Object.assign({}, state, {
        projectPics: action.result,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/landing.js